const account_center = {
    not_enabled: 'Account center is not enabled.',
    field_not_editable: 'Field is not editable.',
    field_not_enabled: 'Field is not enabled.',
};
export default Object.freeze(account_center);
